<template>
  <div class="price-list-box">
    <div class="title-container">
      <img src="./img/price-topic.png" class="topic-img-2" alt="">
    <!--<div class="price-list-title">料金</div>-->
    </div>
    <div class="price-list-img-box">
      <!--  <a src=""><img class="price-list-img" src="./img/price-tanpatsu.jpg" alt="単発プラン"></a>  -->
      <a src=""><img class="price-list-img" src="./img/price-tanpatsu.jpg" alt="単発プラン"></a>
      <!--  <a src=""><img class="price-list-img" src="./img/price-kayoi.jpg" alt="定額プラン"></a> -->
      <a src=""><img class="price-list-img" src="./img/price-kayoi.jpg" alt="定額プラン"></a>
    </div>
    <p class="price-list-text">機械ごとのサブスクプランや、単発プランも幅広く用意しております。</p>
    <ButtonReadMore class="price-list-button" linkPath="./menu"></ButtonReadMore>
    <div class="price-list-container"></div>
  </div>
</template>

<script>
import ButtonReadMore from '../../components/ButtonReadMore.vue'


export default {
  name: 'PriceList',
  components:{
    ButtonReadMore,
  }
}
</script>

<style scoped>
  .price-list-box{
    width: 100vw;
    display: inline-block;
    text-align: center;
  }

   /* PC表示 */
  @media screen and (min-width:821px){
    .price-list-title{
      font-size: 24px;
      color: white;
      background-color: var(--main-color);
      display: inline-block;
      padding:0.8em 4em;
    }

    .price-list-img-box{
      display: flex;
      justify-content: center;
    }

    .price-list-img{
      display:inline-block;
      width: 40vw;
      margin: 2vw;
    }

    .price-list-text{
      color:white;
      font-size: 20px;
      margin-top: 16px;
      margin-bottom: 40px;
    }

    .price-list-button{
      width: 20vw;
      left: 0;
      right: 0;
      margin: auto;
    }

    .topic-img-2{
      width:30%;
      padding-top:18px;
      padding-bottom:22px;
    }

    .price-list-box{
      padding-top:30px;
      padding-bottom:30px;
      background: var(--main-color);
      /*background: repeating-linear-gradient(-30deg, #61A3B1, #61A3B1 1px,#198898 10px, #198898 10px);*/
    }

  
  }
  /* スマホ表示 */
  @media screen and (max-width:820px){

    .topic-img-2{
      width:47%;
      margin-bottom:10px;
      }
    

.price-list-title{
      font-size: 18px;
      font-weight:600;
      /*color: white;
      background-color: var(--main-color);*/
      color: var(--main-color);
      background-color:white;
      display: inline-block;
      padding:0.8em 4em;
      
    }

    .price-list-img-box{
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin-top: 10px;
    }

    .price-list-img{
      display:inline-block;
      width: 45vw;
      margin: 2vw;
    }

    .price-list-text{
      /*color: var(--main-color);*/
      color:white;
      font-size: 2vw;
      font-weight: 600;
      margin-bottom: 25px;
    }

    .price-list-button{
      width: 50vw;
      left: 0;
      right: 0;
      margin: auto;
    }

    .price-list-box{
      padding-top:30px;
      padding-bottom:30px;
      background: var(--main-color);
      /*background: repeating-linear-gradient(-30deg, #61A3B1, #61A3B1 1px,#198898 10px, #198898 10px);*/
    }
    
  }
</style>
